/* eslint-disable */

// Lib
import { put, takeEvery, select, race, take } from 'redux-saga/effects';

// Api
import { getDashBoardStatistics as getDashBoardStatisticsRequest } from 'api/dashboard';
import {
  getNotifications as getNotificationsRequest,
  markNotificationsAsRead,
} from 'api/notifications';

// Actions
import { getDashBoardStatistics, setDashBoardStatistics, waitForLeavingDashboard } from './actions';
import { getNotifications, updateNotifications } from 'actions/notifications';
import { LOCATION_CHANGE } from 'connected-react-router';
import { getUnreadNotifications } from 'selectors/notifications';
import { Notification } from 'types/notifications';
import { logOut } from 'actions/user';

function* getDashBoardStatisticsSaga() {
  const { role, token } = yield select(state => state.user);

  try {
    const { data } = yield getDashBoardStatisticsRequest(role, token);

    yield put(setDashBoardStatistics(data));
  } catch (error) {
    console.log(error);
  }
}

function* getNotificationsSaga() {
  const token = yield select(state => state.user.token);
  const { data: notifiactions } = yield getNotificationsRequest(token);
  yield put(updateNotifications(notifiactions));
}

function* waitForLeavingDashboardSaga() {
  const { locationChange, logout } = yield race({
    locationChange: take(LOCATION_CHANGE),
    logout: take(logOut().type),
  });
  const token = yield select(state => state.user.token);

  const unreadNotifications = yield select(getUnreadNotifications);
  if (unreadNotifications.length) {
    const { data: updatedNotifications } = yield markNotificationsAsRead(token, {
      ids: unreadNotifications.map((n: Notification) => n.id),
    });
    if (locationChange) {
      yield put(updateNotifications(updatedNotifications));
    }
  }
}

export default function* jobBoardSagas() {
  yield takeEvery(getDashBoardStatistics, getDashBoardStatisticsSaga);
  yield takeEvery(getNotifications, getNotificationsSaga);
  yield takeEvery(waitForLeavingDashboard, waitForLeavingDashboardSaga);
}
